<template>
	<div
		class="panel"
		:class="[
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div
			class="container"
			:class="[
				isBrand? 'sk' : '',
			]"
		>
			<div v-if="isHeaderVisible" class="panel_header">
				<h2>{{ block.block_title }}</h2>
				<div v-if="block.description" v-html="block.description" class="description"></div>
			</div>
			<div class="items-container">
				<div class="row justify-content-between">
					<div
						class="col-12 mb-4"
						:class="[
							block.columns ? 'col-lg-' + 12/block.columns : 'col-lg-4'
						]"
						v-if="block.items"
						v-for="(item, index) in block.items"
						v-bind:key="index"
					>
						<div class="item">
							<div v-if="item.icon" :class="['icon', item.icon]"/>
							<div class="title" v-if="item.title">{{ item.title }}</div>
							<div class="description" v-if="item.description" v-html="item.description"></div>
						</div>
					</div>
					<div class="col-12 mb-4" v-if="fetchedData.id === 19405 || fetchedData.id === 19955">
						<div class="row align-items-end">
							<div class="col-12 col-md-12 mb-4">
								<div class="description border-md-bottom">
									<b-button v-b-modal.exampleModal1 class="h4">

										<span v-if="$i18n.locale === 'ru'">Лидерский стрим</span>
										<span v-if="$i18n.locale === 'en'">Leadership Stream</span>

									</b-button>
								</div>
							</div>
							<div class="col-12 col-md-12">
								<div class="description">
									<b-button v-b-modal.exampleModal2 class="h4">
										<span v-if="$i18n.locale === 'ru'">Иммерсивный опыт</span>
										<span v-if="$i18n.locale === 'en'">Immersive experience</span>
									</b-button>
								</div>
							</div>
						</div>

						<b-modal hide-footer id="exampleModal1" :title="$i18n.locale === 'ru'? 'Лидерский стрим' : 'Leadership Stream'">
							<div v-if="$i18n.locale === 'ru'" class="">
								<p>Лидерский стрим под руководством Андрея Шишакова, Академического директора Программы, проходит через всю Программу.</p>
								<p>Процесс совершенствования лидерского стиля, рефлексии собственного трансформационного опыта детально продуман и реализован через сквозной трек, состоящий из чёткой последовательности взаимосвязанных тем и методик.</p>
								<p>Те, кто частично определились в своей самоактуализации и те, кто находятся в процессе, сформируют самоорганизующуюся систему, поделятся опытом, взглядами и жизненными позициями.</p>
							</div>

							<div v-if="$i18n.locale === 'en'" class="">
								<p>The Leadership Stream led by A. Shishakov, Programme Academic Director, runs throughout the Programme.</p>
								<p>The process of improving your leadership style and reflecting on your transformational experience is carefully crafted and implemented through an end-to-end track consisting of a clear sequence of interrelated topics and techniques.</p>
								<p>Those who are already well into their path to self-actualization and those who are still in the process will make up a self-organizing system, share experiences, views and attitudes.
								</p>
							</div>


						</b-modal>

						<b-modal hide-footer id="exampleModal2" :title="$i18n.locale === 'ru'? 'Иммерсивный опыт' : 'Immersive experience' ">
							<div v-if="$i18n.locale === 'ru'" class="">
								<p>Это погружение в социальную, культурную и экономическую системы других стран. </p>
								<p>Это непосредственное участие в деятельности, соприкосновение с новыми культурными кодами, традициями и вызовами.</p>
								<p>Это усиление восприятия нового опыта и, как следствие, образовательного результата.</p>
								<ul>
									<li>Формирование нестандартных инновационных подходов к управленческой деятельности</li>
									<li>Новый источник вдохновения, видения и мотивации</li>
									<li>Выход за рамки своего привычного опыта</li>
									<li>Гибкость взглядов и новый опыт на всех уровнях восприятия (сенсорный, визуальный, ментальный)</li>
									<li>Определение своего масштаба, ценностей, границ и барьеров</li>
									<li>Новые модели действий и реакций в команде и обществе.</li>
								</ul>
							</div>

							<div v-if="$i18n.locale === 'en'" class="">
								<p>It will be an immersion in the social, cultural, and economic systems of other countries. </p>
								<p>It will be a direct participation in activities, a contact with new cultural codes, traditions and challenges.</p>
								<p>It will be a heightened perception of new experiences and, consequently, of the educational outcome.</p>
								<ul>
									<li>Shaping non-standard, innovative approaches to management</li>
									<li>A new source of inspiration, vision and motivation</li>
									<li>Going beyond your usual experiences</li>
									<li>Flexible views and new experiences on all levels of perception (sensory, visual, mental)</li>
									<li>Defining your scope, values, boundaries and barriers</li>
									<li>New team or community-level action / reaction models.</li>
								</ul>
							</div>
						</b-modal>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel'

export default {
	name: "DraftSteps2",
	mixins: [panel],
	props: ["block"],
}
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/dev/draft-steps-2";
</style>
